export default "__VITE_ASSET__CBTaKbQN__"